export const SET_USER = 'SET_USER';
export const UPDATE_LOAD_USER = 'UPDATE_LOAD_USER';
export const UPDATE_AUTH_USER = 'UPDATE_AUTH_USER';
export const LOGOUT="LOGOUT";